import { NavLink } from "react-router-dom"
import logo from "../images/logo_black.png"

function Footer() {
  return (
    <footer className="footer">
      <div className="footerMain row spacebetween">
        <div className="footerLogo">
          <img src={logo} alt="Prebifarm" />
        </div>
        <nav className="footerLinks row">
          <NavLink to="/">Inicio</NavLink>
          <a href="http://prebifarm.com.ar/home" target="_blank" rel="noreferrer">Prebifarm</a>
          <a href="http://prebifarm.com.ar/contacto" target="_blank" rel="noreferrer">Contacto</a>
        </nav>
      </div>
      <div className="footerBottom row spacebetween">
        <span>© 2025 Prebifarm. Todos los derechos reservados.</span>
        <span>Desarrollado por <strong>Florencia Molle</strong></span>
      </div>
    </footer>
  )
}

export default Footer
